<div class="w-full rounded-2xl bg-linear-(--my-gradient1) border-[#D9D9D9] shadow-(--my-shadow) pt-8 lg:pt-15 px-2 lg:px-5 mb-4 mb-md-0">
  <p class="text-white font-bold text-xl md:text-2xl lg:text-4xl xl:text-[45px] capitalize text-center mb-1">Welcome,</p>
  <p class="text-white font-normal text-lg md:text-xl lg:text-2xl xl:text-3xl text-center">Forgot your password</p>
  <div class="bg-white mt-6 lg:mt-10 w-full rounded-xl">
    <div class="p-4 md:py-8 md:px-10 xl:py-10 xl:px-20 rounded-xl bg-white">
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="verifyOTP()">
        <p class="text-444 font-bold text-base md:text-xl xl:text-2xl mb-4 lg:mb-8">Forgot Password</p>

        <p class="text-sm lg:text-base xl:text-lg text-[#898989] mb-4">Please enter your registered email address to reset your password</p>

        <div class="relative mb-4 lg:mb-6">
          <input type="email" id="emailId" formControlName="email"
            class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base xl:text-base text-444 font-normal bg-transparent rounded-lg border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
            placeholder=" " />
          <label for="emailId"
            class="absolute text-sm lg:text-base xl:text-base text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Email Address</label>
          
          <div *ngIf="forgotPasswordForm.get('email')?.touched && forgotPasswordForm.get('email')?.invalid" class="text-red-500 text-sm mt-1">
            <span *ngIf="forgotPasswordForm.get('email')?.errors?.['required']">*Email is required</span>
            <span *ngIf="forgotPasswordForm.get('email')?.errors?.['email']">*Please enter a valid email address</span>
          </div>
        </div>

        <div class="flex items-center justify-center mt-6 md:mt-20">
          <button type="submit" [disabled]="isLoading"
            class="flex items-center justify-center cursor-pointer px-5 md:px-7 lg:px-10 w-[150px] lg:w-[300px] py-2 lg:py-3.5 text-base md:text-lg lg:text-2xl font-bold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-lg text-center disabled:opacity-70 disabled:cursor-not-allowed">
            <ng-container *ngIf="!isLoading; else loadingSpinner">Send OTP</ng-container>
            <ng-template #loadingSpinner>
              <i class="fas fa-spinner fa-spin mr-2"></i> Sending...
            </ng-template>
          </button>
        </div>
        <p class="font-normal text-sm lg:text-lg text-center mt-6 text-c19725"><a routerLink="/login" class="hover:underline">Back to Sign In</a></p>
      </form>
    </div>
  </div>
</div>

